<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="四选一" @back="goBack" /></span>
          <div style="margin-left: 50px;margin-top: 20px;">
            <el-button v-permisaction="['config:rewardEggEdit:add']" type="primary" @click="dialogVisible = true">添加等级</el-button>
          </div>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="500px;"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择类型">
                <el-select v-model="levelFormData.type" style="width: 150px" placeholder="请选择">
                  <el-option
                    v-for="item in conditionType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="数值">
                <el-input v-model.number="levelFormData.min_level" style="width: 100px;" placeholder="最小值" />
              </el-form-item>
              <el-form-item label="-">
                <el-input v-model.number="levelFormData.max_level" style="width: 100px;" placeholder="最大值" />
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="addLevel">保存</el-button>
            </span>
          </el-dialog>

          <el-dialog
            title="提示"
            :visible.sync="dialogVisibleScoreEvent"
            width="500px"
          >
            <el-form :inline="true" class="demo-form-inline" style="margin: 10px 0px 0px 20px;">
              <el-form-item label="选择分组">
                <el-select v-model="scoreFormData.group" style="width: 150px" multiple placeholder="请选择">
                  <el-option
                    v-for="item in groups"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleScoreEvent = false">取 消</el-button>
              <el-button type="primary" @click="addGroup()">保存</el-button>
            </span>
          </el-dialog>

        </div>

        <el-tabs v-model="levelActiveName" tab-position="left" style="height: 100%;" @tab-click="handleClick">
          <el-tab-pane v-for="(tabItem,index) in tabPane" :key="index" :name="tabItem.label" :label="getLabelName(tabItem.label)" @tab-remove="delCond">
            <template #label>
              <div>
                {{ getLabelName(tabItem.label) }}
                <!--                <i v-if="!checkFormData(tabItem.label)" v-permisaction="['config:rewardEggEdit:del']" class="el-icon-circle-close" style="margin-left:5px;font-size: 14px" @click="delCond(tabItem.label)" />-->
              </div>
            </template>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!--------  等级配置----->
              <el-form :inline="true">
                <el-form-item label="选择类型">
                  <el-select v-model="tabItem.type" style="width: 150px" placeholder="请选择" @change="(v)=>{return levelChangeType(v, tabItem.label)}">
                    <el-option
                      v-for="item in conditionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数值范围">
                  <el-input v-model.number="tabItem.min_level" style="width: 100px;" placeholder="最小值" @change="(v)=>{return levelChange(v, 1,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
                <el-form-item label="-">
                  <el-input v-model.number="tabItem.max_level" style="width: 100px;" placeholder="最大值" @change="(v)=>{return levelChange(v, 0,tabItem.type,tabItem.bak_min_level, tabItem.bak_max_level)}" />
                </el-form-item>
              </el-form>
              <!--------  等级配置----->
              <el-button style="margin: 10px 0 10px 0" @click="addScoreEvent(tabItem.label)">+分组</el-button>
              <el-form>
                <div v-if="formData.hasOwnProperty(tabItem.label)">
                  <el-row v-for="(scoreItem, scoreIndex) in formData[tabItem.label]" :key="scoreIndex">
                    <el-card class="box-card" style="margin-top: 10px">
                      <div slot="header" class="clearfix" style="height: 60px;">
                        <el-form :inline="true">
                          <el-form-item label="分组">
                            <el-select v-model="scoreItem.group_bak" multiple placeholder="请选择" style="width: 600px;" @change="(v)=>{return groupChange(v,tabItem.label,scoreItem.group_name)}">
                              <el-option
                                v-for="item in groups"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                              />
                            </el-select>
                          </el-form-item>
                        </el-form>
                      </div>
                      <el-form>
                        <el-form-item label="体力参数" style="margin-top: 10px;">
                          <el-input v-model.number="scoreItem.data[0].rewards.spinCe" style="width: 120px;" placeholder="体力参数" />
                        </el-form-item>
                        <el-table :data="scoreItem.data[0].rewards.stages" border stripe>
                          <el-table-column prop="spinCe" label="关卡">
                            <template slot-scope="scope">
                              <el-input v-model.number="scope.row.start" placeholder="关卡" />
                            </template>
                          </el-table-column>
                          <el-table-column label="奖励1">
                            <template slot-scope="scope">
                              <ActReward :read-only="true" :value="scope.row.list[0].prize" />
                            </template>
                          </el-table-column>
                          <el-table-column label="奖励2">
                            <template slot-scope="scope">
                              <ActReward :read-only="true" :value="scope.row.list[1].prize" />
                            </template>
                          </el-table-column>
                          <el-table-column label="奖励3">
                            <template slot-scope="scope">
                              <ActReward :read-only="true" :value="scope.row.list[2].prize" />
                            </template>
                          </el-table-column>
                          <el-table-column label="奖励4">
                            <template slot-scope="scope">
                              <ActReward :read-only="true" :value="scope.row.list[3].prize" />
                            </template>
                          </el-table-column>
                          <el-table-column prop="spinCe" label="彩蛋配置">
                            <template slot-scope="scope">
                              <el-button type="text" style="margin-left: 16px;" @click="drawer[tabItem.label][scoreItem.group_name][scope.$index].visible = true">
                                彩蛋配置
                              </el-button>
                              <el-drawer
                                title="彩蛋配置"
                                :visible.sync="drawer[tabItem.label][scoreItem.group_name][scope.$index].visible"
                                size="700px"
                                :before-close="(d)=>handleClose2(d,tabItem.label,scoreItem.group_name,scope.$index)"
                                append-to-body
                              >
                                <el-form :inline="true">
                                  <el-row v-for="(detail, idx) in scope.row.list" :key="idx">
                                    <el-form-item label="ID" style="margin-top: 10px;">
                                      <el-input v-model.number="detail.stage" readonly style="width: 120px;" placeholder="ID" />
                                    </el-form-item>
                                    <el-form-item label="权重" style="margin-top: 10px;">
                                      <el-input v-model.number="detail.v" style="width: 120px;" placeholder="权重" />
                                    </el-form-item>
                                    <el-form-item label="奖励" style="margin-top: 10px;">
                                      <ActReward :value="detail.prize" />
                                    </el-form-item>
                                  </el-row>
                                </el-form>
                              </el-drawer>
                            </template>
                          </el-table-column>
                          <el-table-column prop="stage" label="操作">
                            <template slot-scope="scope">
                              <el-button v-permisaction="['config:rewardEggEdit:del']" type="danger" @click="delEvent(tabItem.label,scoreItem.group_name ,scope.$index)">删除</el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-button style="margin-top: 10px" type="primary" @click="addEvent(tabItem.label,scoreItem.group_name)">+</el-button>
                        <el-button v-permisaction="['config:rewardEggEdit:add']" :disabled="isOnline === 1" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
                        <el-button v-if="scoreItem.id > 0" :disabled="isOnline === 1" type="danger" @click="del(tabItem.label,scoreItem.group_name, scoreItem.id)">删除</el-button>
                      </el-form>
                    </el-card>
                  </el-row>
                </div>
              </el-form>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户复活间隔配置</span>
        </div>
        <el-form>
          <el-table :data="reward_conf" border stripe>
            <el-table-column prop="ri" label="阶段">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.ri" placeholder="关卡" />
              </template>
            </el-table-column>

            <el-table-column prop="riCe" label="系数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.riCe" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button type="danger" @click="confDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-button style="margin-top: 10px" type="primary" @click="confAdd()">+</el-button>
        <el-button style="margin-top: 10px" type="primary" :disabled="isOnline === 1" @click="confSubmit()">保存</el-button>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>关卡修正系数</span>
        </div>
        <el-form>
          <el-table :data="reward_pro" border stripe>
            <el-table-column prop="stage" label="关卡">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stage" placeholder="关卡" />
              </template>
            </el-table-column>

            <el-table-column prop="stageCe" label="系数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stageCe" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
                <el-button type="danger" @click="proDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-button style="margin-top: 10px" type="primary" @click="proAdd()">+</el-button>
        <el-button style="margin-top: 10px" type="primary" :disabled="isOnline === 1" @click="proSubmit()">保存</el-button>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>复活礼包数据</span>
        </div>
        <el-form>
          <el-table :data="extra_data" border stripe>
            <el-table-column prop="stage" label="关卡">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.stage" placeholder="关卡" />
              </template>
            </el-table-column>

            <el-table-column prop="bet" label="倍数">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.bet" placeholder="倍数" />
              </template>
            </el-table-column>

            <el-table-column prop="spins" label="体力">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.spins" placeholder="体力" />
              </template>
            </el-table-column>

            <el-table-column prop="price" label="价格">
              <template slot-scope="scope">
                <el-select v-model="scope.row.price" placeholder="请选择" @change="(v)=>priceChange(v,scope.$index)">
                  <el-option
                    v-for="(item, index) in shopSku"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </template>
            </el-table-column>
            <!--            <el-table-column prop="buyMoney" label="购买价格">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-input v-model.number="scope.row.buyMoney" placeholder="buyMoney" />-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column>
              <template slot-scope="scope">
                <el-button type="danger" @click="extraDel(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-button style="margin-top: 10px" type="primary" @click="extraAdd()">+</el-button>
        <el-button style="margin-top: 10px" type="primary" :disabled="isOnline === 1" @click="extraSubmit()">保存</el-button>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>保护配置</span>
        </div>
        <el-form ref="stage_reward" :model="stage_reward" :inline="true">
          <!--          <el-form-item label="配置类型">-->
          <!--            <el-select v-model="stage_reward.confType" placeholder="请选择">-->
          <!--              <el-option-->
          <!--                v-for="item in confTypes"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item v-if="stage_reward.confType === 0" label="随机系数">
            <el-button type="text" @click="ExtremeDialogVisible = true">随机系数配置</el-button>
            <span>{{ stage_reward.min }} - {{ stage_reward.max }}</span>
            <el-dialog
              title="提示"
              :visible.sync="ExtremeDialogVisible"
              width="400px"
              :before-close="handleClose"
            >
              <el-form :inline="true">
                <el-form-item label="最小值" style="margin-top: 10px;">
                  <el-input v-model.number="stage_reward.rand.min" style="width: 110px;" placeholder="最小值" />
                </el-form-item>
                <el-form-item label="最大值" style="margin-top: 10px;">
                  <el-input v-model.number="stage_reward.rand.max" style="width: 110px;" placeholder="最大值" />
                </el-form-item>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="ExtremeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="ExtremeDialogVisible = false">确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>
          <el-form-item v-if="stage_reward.confType === 1" label="随机系数">
            <el-button type="text" @click="NewExtremeDialogVisible = true">随机系数配置</el-button>
            <el-dialog
              title="提示"
              :visible.sync="NewExtremeDialogVisible"
              width="500px"
              :before-close="handleClose"
            >
              <el-row v-for="(item, index) in stage_reward.randConf" :key="index">
                <el-form :inline="true">
                  <el-form-item style="margin-top: 10px;">
                    <span v-if="index === 0">低等级</span>
                    <span v-if="index === 1">高等级</span>
                  </el-form-item>
                  <el-form-item label="最小值" style="margin-top: 10px;">
                    <el-input v-model.number="item.min" style="width: 110px;" placeholder="最小值" />
                  </el-form-item>
                  <el-form-item label="最大值" style="margin-top: 10px;">
                    <el-input v-model.number="item.max" style="width: 110px;" placeholder="最大值" />
                  </el-form-item>
                </el-form>

              </el-row>
              <span slot="footer" class="dialog-footer">
                <el-button @click="NewExtremeDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="NewExtremeDialogVisible = false">确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>
          <el-form-item label="保护配置">
            <el-button type="text" @click="protectDialogVisible = true">保护配置</el-button>
            <el-dialog
              title="提示"
              :visible.sync="protectDialogVisible"
              width="1200px"
              :before-close="handleClose4"
            >
              <el-form :inline="true">
                <el-table :data="stage_reward.protect" border stripe>
                  <!--                  <el-table-column prop="lv" label="用户等级">-->
                  <!--                    <template slot-scope="scope">-->
                  <!--                      <el-input v-model.number="scope.row.lv" placeholder="用户等级" />-->
                  <!--                    </template>-->
                  <!--                  </el-table-column>-->
                  <el-table-column prop="lvMin" label="等级范围" width="200px">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.lvMin" style="width: 40%" />
                      -
                      <el-input v-model="scope.row.lvMax" style="width: 40%" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="m" label="产出系数">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.m" placeholder="产出系数" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="maxBet" label="上限倍率">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.maxBet" placeholder="上限倍率" />
                    </template>
                  </el-table-column>

                  <el-table-column prop="minBet" label="下限倍率">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.minBet" placeholder="下限倍率" />
                    </template>
                  </el-table-column>

                  <el-table-column prop="stage" label="保护层数">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.stage" placeholder="保护层数" />
                    </template>
                  </el-table-column>

                  <el-table-column prop="ce" label="保护基数">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.ce" placeholder="保护基数" />
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button type="danger" @click="stageRewardDel(scope.$index)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-button style="margin-top: 10px" type="primary" @click="stageRewardAdd()">+</el-button>
              </el-form>
              <span slot="footer" class="dialog-footer">
                <el-button @click="protectDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="protectDialogVisible = false">确 定</el-button>
              </span>
            </el-dialog>
          </el-form-item>

        </el-form>
        <el-button type="primary" :disabled="isOnline === 1" @click="stageRewardSumit()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import Vue from 'vue'
import { getChessBoardType, getRewardType } from '@/api/config/slot'
import {
  delActivtyFirstRewardCfg,
  exportActivtyRewardCfg, getActivtyAllList, getActivtyList,
  getActivtyRewardCfg,
  getActivtyStageRewardCfg, getActivityTypeToMap,
  getConditionTypesList,
  importActivtyRewardCfg,
  updateActivtyExtraData,
  updateActivtyProData,
  updateActivtyRewardCfg, updateActivtyRewardConfData,
  updateActivtyStageRewardCfg
} from '@/api/config/activity-cfg'
import { getToken } from '@/utils/auth'
import { getSku } from '@/api/config/shop-cfg'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { getRewardListForType } from '@/utils'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getAvatarCfgAll } from '@/api/config/avatar-cfg'
import ActReward from '@/components/Reward/act.vue'
export default {
  name: 'RewardEggEdit',
  components: { ActReward },
  data() {
    return {
      isOnline: 0,
      ucType: 0,
      protectDialogVisible: false,
      ExtremeDialogVisible: false,
      NewExtremeDialogVisible: false,
      reward_conf: [],
      reward_pro: [],
      extra_data: [],
      stage_reward: {
        rand: {
          min: 0,
          max: 0
        },
        randConf: [
          { min: 0, max: 0 },
          { min: 0, max: 0 }
        ],
        protect: [{
          lv: 0,
          // lvMin: 0,
          // lvMax: 0,
          m: 0,
          maxBet: 0,
          minBet: 0,
          stage: 0,
          ce: 0
        }],
        confType: 1
      },
      eggDialogVisible: {},
      rewardDialogVisible: {},
      loading: false,
      aid: 0,
      tabPane: [
        // { 'label': '1-99', 'min_level': 1, 'bak_min_level': 1, 'bak_max_level': 99, 'max_level': 99, 'min_score': 1, 'max_score': 99, add: true }
      ],
      shopSku: [],
      visibleArr: {},
      buyType: [{ 'value': 1, 'label': '金币' }, { 'value': 2, 'label': '付费' }],
      coinType: [
        { label: 'money1', value: 'money1' },
        { label: 'money2', value: 'money2' },
        { label: 'money3', value: 'money3' },
        { label: 'money4', value: 'money4' },
        { label: 'money5', value: 'money5' },
        { label: 'money6', value: 'money6' }
      ],
      drawer: {},
      direction: 'rtl',
      rewardType: [],
      chessBoardType: [],
      groups: [
        { label: '默认分组', value: 0 }
        // { label: '免费玩家', value: 1 },
        // { label: '付费玩家', value: 2 }
      ],
      conditionType: [],
      confTypes: [
        {
          'value': 1,
          'label': '新配置'
        }
        // {
        //   'value': 0,
        //   'label': '老配置'
        // }
      ],
      actType: '',
      appearType: [
        { 'label': '否', value: 0 },
        { 'label': '是', value: 1 }
      ],
      dialogVisible: false,
      dialogVisibleScoreEvent: false,
      levelFormData: {
        min_level: 0,
        max_level: 0,
        type: 'level'
      },
      scoreFormData: {
        group: [],
        group_name: '',
        group_bak: [],
        level_name: '',
        event_name: ''
      },
      activeName: 'first',
      levelActiveName: '',
      copyFormData: {},
      formData: {},
      activtyToType: [],
      activtyToTypeId: [],
      activtyList: []
    }
  },
  created() {
    this.getSkuList()
    this.getConditionTypeData()
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.typeChange('')
    this.getTables()
    // this.getChessBoardType()
    this.getStageReward()
    this.getGroup()
  },
  methods: {
    getSkuList() {
      getSku({ type: 3 }).then(res => {
        if (res.code === 200) {
          this.shopSku = []
          res.data.forEach((item) => {
            this.shopSku.push({ label: item.price, value: item.price, sku: item.sku })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    priceChange(v, index) {
      let sku = ''
      this.shopSku.forEach((item) => {
        if (item.value === v) {
          sku = item.sku
        }
      })
      this.extra_data[index].sku = sku
    },
    getConditionTypeData() {
      getConditionTypesList({ data: 1 }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.conditionType.push({ 'label': res.data[i], 'value': i })
          }
        }
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs['upload'].clearFiles()
      importActivtyRewardCfg({ type: this.actType, name: this.aid, data: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportActivtyRewardCfg({ id: this.aid, type: this.actType }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    handleClose(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    handleClose2(done, levelName, scoreName, index) {
      this.drawer[levelName][scoreName][index].visible = false
    },
    handleClose3(done, levelName, scoreName, index, idx) {
      this.rewardDialogVisible[levelName][scoreName][index.toString()][idx].visible = false
    },
    handleClose4(done) {
      this.protectDialogVisible = false
    },
    onSubmit(noTips = false, condSub = false) {
      const data = JSON.stringify(this.formData)
      console.log('data', data)
      const formData = this.formData
      let levelIndex = 0
      const postFormDataCondition = {}
      let _postData = []
      const postFormData = {}
      for (const i in formData) {
        this.levelActiveName = i
        let groupIndex = 0
        levelIndex++
        const scoreData = formData[i]
        const [type, minLevel, maxLevel] = i.split('-')
        for (const i2 in scoreData) {
          groupIndex++
          const scoreItem = scoreData[i2]
          console.log('activeName', this.activeName)
          const key = levelIndex + '-' + groupIndex
          if (parseInt(minLevel) > parseInt(maxLevel)) {
            this.msgError('最低等级不能大于最高等级')
            return
          }

          const _formdata = scoreItem.data[0]
          for (const i in _formdata.rewards.stages) {
            const _reward = _formdata.rewards.stages[i]
            if (_reward.start <= 0) {
              this.msgError('关卡不能是0')
              return
            }

            for (const k in _reward.list) {
              const list = _reward.list[k]
              for (const li in list.prize) {
                const p = list.prize[li]
                if (p.type === 65) {
                  _reward.list[k].prize[li].num *= 10000
                }
              }
            }

            _formdata.rewards.stages[i] = _reward
          }

          if (condSub && scoreItem.data[0].rewards.length <= 0) {
            continue
          }

          const condition = {
            start: parseInt(minLevel),
            end: parseInt(maxLevel),
            shushu: [],
            type: type
          }

          const condition1 = {
            start: 0,
            end: 0,
            shushu: scoreItem.group,
            type: 'shushu'
          }

          postFormDataCondition[key] = [condition, condition1]
          console.log('条件 ', postFormDataCondition)
          postFormData[key] = {
            'level': minLevel + '-' + maxLevel,
            'data': scoreItem.data[0]
          }

          const _data = scoreItem.data[0]
          _data.aid = this.aid
          const stage = {}
          stage[key] = condition
          _data.stage = key
          _postData.push(_data)
        }
      }
      const newPostData = Object.assign([], _postData)
      const postCondition = JSON.stringify({ aid: this.aid, condition: postFormDataCondition })
      // console.log('newPostData', newPostData.length)

      // 使用 for 循环修改 JSON 数据
      for (let i = 0; i < newPostData.length; i++) {
        const rewards = newPostData[i].rewards
        console.log('rewards', rewards)
        const stages = rewards.stages
        const newStages = {}
        for (let k = 0; k < stages.length; k++) {
          const stage = stages[k]
          const newList = {}
          for (let l = 0; l < stage.list.length; l++) {
            newList[stage.list[l].stage] = stage.list[l]
          }
          newStages[stage.start] = { start: stage.start, list: newList }
        }
        rewards.stages = newStages
      }

      // 打印修改后的 JSON 数据
      _postData = JSON.stringify(newPostData)
      console.log('_postData', _postData)
      updateActivtyRewardCfg({ type: this.actType, name: postCondition, data: _postData }).then(res => {
        if (res.code === 200) {
          if (!noTips) {
            this.msgSuccess(res.msg)
          }
          this.getTables(this.levelActiveName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      this.tabPane = []
      this.formData = []
      getActivtyRewardCfg({ id: this.aid }).then(res => {
        const data = res.data.data
        console.log(data)
        // const tab = {}
        const cond = res.data.cond.condition
        for (const i in cond) {
          const val = cond[i][0]
          const val1 = cond[i][1]
          const levelName = val.type + '-' + val.start + '-' + val.end
          const scoreName = val1.shushu.join('-')

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer, levelName)) {
            this.$set(this.drawer, levelName, {})
            // 关卡
            this.$set(this.eggDialogVisible, levelName, [])
            // 奖励
            this.$set(this.rewardDialogVisible, levelName, [])
          }

          // 初始化弹窗
          if (!Object.prototype.hasOwnProperty.call(this.drawer[levelName], scoreName)) {
            this.$set(this.drawer[levelName], scoreName, [])
            this.$set(this.eggDialogVisible[levelName], scoreName, [])
            this.$set(this.rewardDialogVisible[levelName], scoreName, {})
          }

          // eslint-disable-next-line no-unused-vars
          if (!Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
            this.$set(this.formData, levelName, {})
          }

          // if (!Object.prototype.hasOwnProperty.call(this.formData[levelName][scoreName], 'data')) {
          //   this.$set(this.formData[levelName][scoreName], 'data', [])
          // }

          this.$set(this.formData[levelName], scoreName, {
            'group': val1.shushu,
            'group_name': scoreName,
            'group_bak': val1.shushu,
            data: [{ rewards: [] }]
          })

          for (const ii in data) {
            const _event = data[ii]
            if (_event.stage === i) {
              // 转换 rewards 下的 stages 为数组
              const _data = _event.rewards
              const stages = _data.stages
              const stagesArray = []
              for (const stageKey in stages) {
                if (Object.prototype.hasOwnProperty.call(stages, stageKey)) {
                  stagesArray.push(stages[stageKey])
                }
              }

              _data.stages = stagesArray

              // 转换 list 为数组
              for (let i = 0; i < _data.stages.length; i++) {
                const stages = _data.stages[i]
                const list = stages.list
                const listArray = []
                for (const listKey in list) {
                  listArray.push(list[listKey])
                }
                _data.stages[i].list = listArray
              }

              // 打印修改后的 JSON 数据
              // console.log('stages', _data)
              _data.stages.forEach((item, idx) => {
                for (const i in item.list) {
                  const list = item.list[i]
                  for (const pi in list.prize) {
                    const p = list.prize[pi]
                    if (p.type === 65) {
                      _data.stages[idx].list[i].prize[pi].num /= 10000
                    }
                  }
                }
                this.drawer[levelName][scoreName].push({ visible: false })
                this.eggDialogVisible[levelName][scoreName].push({ visible: false })
                const key = idx.toString()
                this.$set(this.rewardDialogVisible[levelName][scoreName], key, [])
                for (let i = 0; i < 4; i++) {
                  this.rewardDialogVisible[levelName][scoreName][key].push({ visible: false })
                }
              })
              this.$set(this.formData[levelName][scoreName], 'data', [{ rewards: _data }])
              this.$set(this.formData[levelName][scoreName], 'id', _event.id)
            }
          }

          // 等级
          let findIndex = -1
          this.tabPane.forEach((item, index) => {
            if (item.label === levelName) {
              findIndex = index
            }
          })

          if (findIndex === -1) {
            this.tabPane.push({
              label: levelName,
              type: val.type,
              bak_type: val.type,
              min_level: val.start,
              max_level: val.end,
              bak_min_level: val.start,
              bak_max_level: val.end,
              add: true
            })
          }
          this.tabPane.forEach((item, index) => {
            if (index === 0) {
              this.levelActiveName = item.label
            }
          })
        }
      })

      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          // console.log(res.data.list[0])
          const data = res.data.list[0]
          var reward_conf = []
          for (const i in data.reward_conf) {
            reward_conf.push(data.reward_conf[i])
          }

          this.reward_conf = reward_conf
          var exportData = []
          for (const i in data.extraData) {
            exportData.push(data.extraData[i])
          }
          this.extra_data = exportData

          var reward_pro = []
          for (const i in data.reward_pro) {
            reward_pro.push(data.reward_pro[i])
          }
          this.reward_pro = reward_pro
          // this.reward_pro = res.data.list[0].reward_pro
        }
      })
    },
    convertObjectToArray(data) {
      for (const key in data) {
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty(key)) {
          if (typeof data[key] === 'object' && data[key]) {
            if (key === 'list' || key === 'stages') {
              data[key] = Object.values(data[key])
            }
            this.convertObjectToArray(data[key])
          }
        }
      }
      return data
    },
    levelChangeType(newVal, levelName) {
      // 是否存在相同类型
      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === levelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })

      if (fileIndex === -1) {
        this.msgError('修改失败')
        return
      }

      const oldTabPane = this.tabPane[fileIndex]
      const oldLevelName = oldTabPane.label
      const newLabelName = newVal + '-' + oldTabPane.min_level + '-' + oldTabPane.max_level
      for (const i in this.tabPane) {
        const tabPane = this.tabPane[i]
        if (tabPane.label === newLabelName) {
          this.msgError('当前类型配置已经存在')
          return
        }
      }
      oldTabPane.label = newLabelName
      this.tabPane[fileIndex] = oldTabPane
      this.levelActiveName = newLabelName
      if (Object.prototype.hasOwnProperty.call(this.formData, oldLevelName)) {
        const oldData = this.formData[oldLevelName]
        Vue.delete(this.formData, oldLevelName)
        this.$set(this.formData, newLabelName, oldData)
      }
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLabelName, oldVisle)

      // 修改弹窗
      const oldeggVisle = this.eggDialogVisible[oldLevelName]
      Vue.delete(this.eggDialogVisible, oldLevelName)
      this.$set(this.eggDialogVisible, newLabelName, oldeggVisle)

      // 修改弹窗
      const oldrewardVisle = this.rewardDialogVisible[oldLevelName]
      Vue.delete(this.rewardDialogVisible, oldLevelName)
      this.$set(this.rewardDialogVisible, newLabelName, oldrewardVisle)
    },
    levelChange(newVal, isMin, type, bakMin, bakMax) {
      newVal = parseInt(newVal)
      const oldLevelName = type + '-' + bakMin + '-' + bakMax
      let newLevelName = ''
      if (isMin) {
        newLevelName = type + '-' + newVal + '-' + bakMax
      } else {
        newLevelName = type + '-' + bakMin + '-' + newVal
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, newLevelName)) {
        // if (this.formData.hasOwnPropert(newLevelName)) {
        this.msgError('修改失败')
        return
      }

      const oldData = this.formData[oldLevelName]
      Vue.delete(this.formData, oldLevelName)
      // eslint-disable-next-line no-undef
      this.$set(this.formData, newLevelName, oldData)
      // 修改弹窗
      const oldVisle = this.drawer[oldLevelName]
      Vue.delete(this.drawer, oldLevelName)
      this.$set(this.drawer, newLevelName, oldVisle)

      // 修改弹窗
      const oldeggVisle = this.eggDialogVisible[oldLevelName]
      Vue.delete(this.eggDialogVisible, oldLevelName)
      this.$set(this.eggDialogVisible, newLevelName, oldeggVisle)

      // 修改弹窗
      const oldrewardVisle = this.rewardDialogVisible[oldLevelName]
      Vue.delete(this.rewardDialogVisible, oldLevelName)
      this.$set(this.rewardDialogVisible, newLevelName, oldrewardVisle)

      let fileIndex = -1
      this.tabPane.filter((res, index) => {
        if (res.label === oldLevelName) {
          // eslint-disable-next-line no-unused-vars
          fileIndex = index
        }
      })
      if (fileIndex > -1) {
        const oldTab = this.tabPane[fileIndex]
        oldTab['label'] = newLevelName
        if (isMin) {
          oldTab['bak_min_level'] = newVal
          oldTab['min_level'] = newVal
        } else {
          oldTab['bak_max_level'] = newVal
          oldTab['max_level'] = newVal
        }
        this.tabPane[fileIndex] = oldTab
      }
      this.levelActiveName = newLevelName
    },
    addReward(levelName, scoreName, index, idx) {
      this.formData[levelName][scoreName].data[0].rewards.stages[index].list[idx].prize.push({
        id: 0,
        num: 0,
        type: 1,
        rtype: 1,
        is_ts: 0,
        skin: 0,
        ts: 0
      })
    },
    removeReward(levelName, scoreName, index, idx, pi) {
      this.formData[levelName][scoreName].data[0].rewards.stages[index].list[idx].prize = this.formData[levelName][scoreName].data[0].rewards.stages[index].list[idx].prize.filter((item, key) => {
        return pi !== key
      })
    },
    addEventReward(levelName, scoreName, index, i) {
      console.log(this.formData[levelName][scoreName].data[index].config[i])
      let propsId = 14
      if (this.formData[levelName][scoreName].data[index].config[i].type === 3) {
        propsId = 1
        if (this.formData[levelName][scoreName].data[index].config[i].reward.length >= 1) {
          return
        }
      }
      this.formData[levelName][scoreName].data[index].config[i].reward.push({
        propsId: propsId,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    addEvent(levelName, scoreName) {
      const start = this.formData[levelName][scoreName].data[0].rewards.stages.length
      this.formData[levelName][scoreName].data[0].rewards.stages.push({
        start: start + 1,
        list: [
          { stage: 1, v: 0, prize: [] },
          { stage: 2, v: 0, prize: [] },
          { stage: 3, v: 0, prize: [] },
          { stage: 4, v: 0, prize: [] }
        ]
      })

      this.drawer[levelName][scoreName].push({ visible: false })
      const len = this.formData[levelName][scoreName].data[0].rewards.stages.length - 1
      const key = len.toString()
      this.$set(this.rewardDialogVisible[levelName][scoreName], key, [])
      for (let i = 0; i < 4; i++) {
        this.rewardDialogVisible[levelName][scoreName][key].push({ visible: false })
      }
    },
    delEvent(levelName, scoreName, index) {
      this.formData[levelName][scoreName].data[0].rewards.stages = this.formData[levelName][scoreName].data[0].rewards.stages.filter((item, key) => {
        return index !== key
      })
    },
    del(levelName, scoreName, id) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delActivtyFirstRewardCfg({ id: id }).then(res => {
            if (res.code === 200) {
              // this.formData[levelName][scoreName].data = []
              this.$delete(this.formData[levelName], scoreName)
              // this.msgSuccess(res.msg)
              this.onSubmit(true)
              // this.getTables()
            } else {
              // this.msgError(res.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    addScoreEvent(levelName) {
      this.scoreFormData.max_score = 0
      this.scoreFormData.min_score = 0
      this.scoreFormData.level_name = levelName
      this.dialogVisibleScoreEvent = true
    },
    addGroup() {
      const score = this.scoreFormData
      if (score.group.length <= 0) {
        this.msgError('请选择分组')
        return
      }
      this.dialogVisibleScoreEvent = false
      const bakGroup = score.group
      const scoreTag = score.group.join('-')
      // eslint-disable-next-line no-prototype-builtins
      if (!Object.prototype.hasOwnProperty.call(this.formData[score.level_name], scoreTag)) {
        this.$set(this.formData[score.level_name], scoreTag, {
          'group': bakGroup,
          'group_name': scoreTag,
          'group_bak': bakGroup,
          'data': []
        })
        this.$set(this.drawer[score.level_name], scoreTag, [])
        this.$set(this.eggDialogVisible[score.level_name], scoreTag, [])
        this.$set(this.rewardDialogVisible[score.level_name], scoreTag, {})
      }

      if (this.formData[score.level_name][scoreTag].data.length > 0) {
        this.msgError('当前分组元素已达上限')
        return
      }

      // 添加第一个元素
      // { start: 1, list: { stage: 1, stepnum: 1, prize: [] }}
      this.formData[score.level_name][scoreTag].data.push({
        aid: 0,
        rewards: {
          spinCe: 0,
          stages: []
        }})

      this.activeName = score.level_name
      this.scoreFormData.group = []
      this.scoreFormData.group_bak = []
      this.scoreFormData.group_name = ''
      // console.log(this.formData)
    },
    addLevel() {
      console.log('添加等级')
      this.dialogVisible = false
      if (this.levelFormData.min_level > this.levelFormData.max_level) {
        this.msgError('最低等级不能大于最大等级')
        return
      }
      const levelName = this.levelFormData.type + '-' + this.levelFormData.min_level + '-' + this.levelFormData.max_level
      if (Object.prototype.hasOwnProperty.call(this.formData, levelName)) {
        // this.msgError('等级已经存在')
        // return
        for (const i in this.tabPane) {
          const tabPane = this.tabPane[i]
          if (tabPane.type === this.levelFormData.type && tabPane.label === levelName) {
            this.msgError('当前配置已经存在')
            return
          }
        }
      }

      this.tabPane.push({
        'label': levelName,
        'type': this.levelFormData.type,
        'bak_type': this.levelFormData.type,
        'min_level': this.levelFormData.min_level,
        'max_level': this.levelFormData.max_level,
        'bak_min_level': this.levelFormData.min_level,
        'bak_max_level': this.levelFormData.max_level,
        add: true
      })
      this.levelActiveName = levelName
      // 初始化等级
      this.$set(this.formData, levelName, {})
      // 初始化弹窗
      this.$set(this.drawer, levelName, {})
      // 关卡
      this.$set(this.eggDialogVisible, levelName, [])
      // 奖励
      this.$set(this.rewardDialogVisible, levelName, [])
    },
    handleClick(tab, event) {
      console.log(tab.name)
      this.activeName = tab.name
    },
    scoreChange(newVal, isMin, levelName, minBak, maxBak) {
      console.log('scoreChange', newVal)
      const oldScoreName = minBak + '-' + maxBak
      let newScoreName = newVal + '-' + maxBak
      if (!isMin) {
        newScoreName = minBak + '-' + newVal
      }
      const oldData = this.formData[levelName][oldScoreName]

      if (isMin) {
        oldData.min_score = newVal
        oldData.min_score_bak = newVal
      } else {
        oldData.max_score = newVal
        oldData.max_score_bak = newVal
      }

      // // 删除旧积分
      Vue.delete(this.formData[levelName], oldScoreName)
      this.$set(this.formData[levelName], newScoreName, oldData)
      console.log(this.formData[levelName])
    },
    getRewardTypeData(ucType) {
      getRewardType({ data: ucType }).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    addEgg(levelName, groupName, index) {
      const count = this.formData[levelName][groupName].data[0].rewards[index].stages.length
      this.formData[levelName][groupName].data[0].rewards[index].stages.push(
        {
          start: count + 1,
          list: [
            { stage: 1, v: 0, prize: [] },
            { stage: 2, v: 0, prize: [] },
            { stage: 3, v: 0, prize: [] },
            { stage: 4, v: 0, prize: [] }
          ]
        }
      )
      this.eggDialogVisible[levelName][groupName].push({ visible: false })
      const len = this.formData[levelName][groupName].data[0].rewards[index].stages.length - 1
      const key = len.toString()
      this.$set(this.rewardDialogVisible[levelName][groupName], key, [])
      for (let i = 0; i < 4; i++) {
        this.rewardDialogVisible[levelName][groupName][key].push({ visible: false })
      }
      console.log(this.rewardDialogVisible[levelName][groupName][key])
    }, delReward(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[index].reward = this.formData[levelName][groupName].data[index].reward.filter((item, key) => {
        return key !== i
      })
    },
    groupChange(v, levelName, oldGroupName) {
      v = v.sort()
      const newGroupName = v.join('-')
      const oldData = this.formData[levelName][oldGroupName]
      this.$delete(this.formData[levelName], oldGroupName)
      oldData.group = v
      oldData.group_bak = v
      oldData.group_name = newGroupName
      console.log('newGroupName', newGroupName)
      if (Object.prototype.hasOwnProperty.call(this.formData[levelName], newGroupName)) {
        this.msgError('当前分组已经存在')
        this.getTables()
        return
      }
      this.$set(this.formData[levelName], newGroupName, oldData)
      // 修改弹窗元素
      const oldVisible = this.drawer[levelName][oldGroupName]
      this.$delete(this.drawer[levelName], oldGroupName)
      this.$set(this.drawer[levelName], newGroupName, oldVisible)
      // 修改弹窗元素
      const oldDiaVisible = this.eggDialogVisible[levelName][oldGroupName]
      this.$delete(this.eggDialogVisible[levelName], oldGroupName)
      this.$set(this.eggDialogVisible[levelName], newGroupName, oldDiaVisible)

      const oldDiaVisible2 = this.rewardDialogVisible[levelName][oldGroupName]
      this.$delete(this.rewardDialogVisible[levelName], oldGroupName)
      this.$set(this.rewardDialogVisible[levelName], newGroupName, oldDiaVisible2)
    },
    getChessBoardType() {
      getChessBoardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessBoardType.push({ 'title': res.data[i], 'id': parseInt(i) })
          }
        }
      })
    },
    removeEgg(levelName, groupName, index, i) {
      this.formData[levelName][groupName].data[0].rewards[index].stages = this.formData[levelName][groupName].data[0].rewards[index].stages.filter((item, key) => {
        return i !== key
      })
    }, getLabelName(label) {
      const arr = label.split('-')
      let typeName = ''
      this.conditionType.forEach((item) => {
        if (item.value === arr[0]) {
          typeName = item.label
        }
      })
      return typeName + '-Lv:' + arr[1] + '-' + arr[2]
    }, mtTypeChange(v, levelName, groupName, index) {
      this.formData[levelName][groupName].data[0].rewards[index].sku = ''
    },
    getRewardList(prize) {
      const reward = getRewardListForType(prize, this.rewardType)
      if (reward) {
        return reward
      }
      return '小丑'
    }, delCond(label) {
      this.$confirm('此操作将永久删除该条件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tabPane = this.tabPane.filter(item => {
          return item.label !== label
        })

        this.onSubmit(false, true)
      })
    },
    checkFormData(label) {
      let count = 0
      for (const i in this.formData[label]) {
        const val = this.formData[label][i]
        count += val.data[0].rewards.length
      }

      if (count > 0) {
        return true
      }

      return false
    },
    confAdd() {
      this.reward_conf.push({
        ri: 1,
        riCe: 0
      })
    },
    confDel(i) {
      this.reward_conf = this.reward_conf.filter((item, index) => {
        return index !== i
      })
    },
    proAdd() {
      this.reward_pro.push({
        stage: 1,
        stageCe: 0
      })
    },
    proDel(i) {
      this.reward_pro = this.reward_pro.filter((item, index) => {
        return index !== i
      })
    },
    extraAdd() {
      this.extra_data.push({
        stage: 1,
        bet: 0,
        spins: 0,
        price: this.shopSku[0].value,
        sku: this.shopSku[0].sku
      })
    },
    extraDel(i) {
      this.extra_data = this.extra_data.filter((item, index) => {
        return index !== i
      })
    },
    stageRewardAdd() {
      this.stage_reward.protect.push({
        lv: 0,
        lvMin: 0,
        lvMax: 0,
        m: 0,
        maxBet: 0,
        minBet: 0,
        stage: 0,
        ce: 0
      })
    },
    stageRewardDel(index) {
      this.stage_reward.protect = this.stage_reward.protect.filter((item, i) => {
        return index !== i
      })
    },
    stageRewardSumit() {
      const newStageReward = Object.assign({}, this.stage_reward)
      if (newStageReward.confType === 0) {
        if (this.stage_reward.rand.min > this.stage_reward.rand.max) {
          this.msgError('随机系数最小值不能大于最大值')
          return
        }
      } else {
        const randConf = {}
        let index = 0
        for (const i in this.stage_reward.randConf) {
          index++
          const val = this.stage_reward.randConf[i]
          if (val.min > val.max) {
            this.msgError('随机系数最小值不能大于最大值')
            return
          }

          randConf[index] = val
        }

        newStageReward.randConf = randConf
      }

      const protect = {}
      let index = 0
      for (const i in newStageReward.protect) {
        index++
        const val = newStageReward.protect[i]
        // if (val.lv <= 0) {
        //   this.msgError('保护配置-用户等级不能小于等于0')
        //   return
        // }

        if (val.lvMin <= 0) {
          this.msgError('保护配置-用户等级起始值不能小于等于0')
          return
        }

        if (val.lvMax <= 0) {
          this.msgError('保护配置-用户等级起始值不能小于等于0')
          return
        }

        if (val.lvMin > val.lvMax) {
          this.msgError('保护配置-用户等级起始值不能大于用户等级结束值')
          return
        }

        if (val.m <= 0) {
          this.msgError('保护配置-产出系数不能小于0')
          return
        }

        if (val.maxBet <= 0) {
          this.msgError('保护配置-上限倍率不能小于0')
          return
        }

        if (val.minBet <= 0) {
          this.msgError('保护配置-下限倍率不能小于0')
          return
        }

        if (val.stage <= 0) {
          this.msgError('保护配置-保护层数不能小于0')
          return
        }

        if (val.ce <= 0) {
          this.msgError('保护配置-保护基数不能小于0')
          return
        }

        protect[index] = val
      }
      newStageReward.protect = protect
      const postData = { type: this.actType, aid: this.aid, reward: newStageReward }
      const data = JSON.stringify(postData)
      updateActivtyStageRewardCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getStageReward()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getStageReward() {
      getActivtyStageRewardCfg({ id: this.aid }).then(res => {
        if (res.code === 200) {
          if (res.data.reward) {
            const reward = res.data.reward
            const randConf = []
            const protect = []
            for (const i in reward.randConf) {
              const val = reward.randConf[i]
              randConf.push(val)
            }
            for (const i in reward.protect) {
              const val = reward.protect[i]
              protect.push(val)
            }
            this.stage_reward.confType = reward.confType
            this.stage_reward.randConf = randConf
            this.stage_reward.rand = reward.rand
            this.stage_reward.protect = protect
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    extraSubmit() {
      const postData = {}
      for (const i in this.extra_data) {
        const val = this.extra_data[i]
        if (val.stage <= 0) {
          this.msgError('关卡不能小于0')
          return
        }

        if (val.bet <= 0) {
          this.msgError('倍数不能小于0')
          return
        }

        if (val.spins <= 0) {
          this.msgError('体力不能小于0')
          return
        }

        postData[parseInt(val.stage)] = val
      }

      console.log(postData)
      // const postData = this.extra_data
      const data = JSON.stringify(postData)
      console.log(data)
      updateActivtyExtraData({ name: this.aid, type: this.actType, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getExtraData()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    proSubmit() {
      const postData = {}
      for (const i in this.reward_pro) {
        const val = this.reward_pro[i]
        if (val.stage <= 0) {
          this.msgError('关卡不能小于0')
          return
        }

        if (val.stageCe <= 0) {
          this.msgError('系数不能小于0')
          return
        }

        postData[val.stage] = val
      }
      // const postData = this.reward_pro
      const data = JSON.stringify(postData)
      console.log(data)
      updateActivtyProData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getExtraData()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    confSubmit() {
      const postData = {}
      for (const i in this.reward_conf) {
        const val = this.reward_conf[i]
        if (val.ri <= 0) {
          this.msgError('阶段不能小于0')
          return
        }

        if (val.riCe <= 0) {
          this.msgError('系数不能小于0')
          return
        }

        postData[val.ri] = val
      }
      // const postData = this.reward_pro
      const data = JSON.stringify(postData)
      console.log('postData', data)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getExtraData()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    typeChange(v) {
      // if (this.activtyToTypeId.includes(v)) {
      let typ = ''
      if (v) {
        typ = this.activtyToType[v]
      }
      getActivtyAllList({ type: typ }).then(res => {
        if (res.code === 200) {
          this.activtyList = res.data
        }
      })
    },
    getActivtyToType() {
      getActivityTypeToMap().then(res => {
        if (res.code === 200) {
          this.activtyToType = res.data
          for (const i in res.data) {
            this.activtyToTypeId.push(parseInt(i))
          }
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }

}
</script>

<style scoped>
</style>
